import ActionConstants from '../actionConstants/userdata';
export const getUserData = (value) => ({
  value,
  type: ActionConstants.USER_DATA
});